import * as z from "zod/v4";

export const getOrdersByChannel = {
  name: "getOrdersByChannel" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    channels: z.array(z.object({ channel: z.string(), count: z.number() })),
  }),
};
